import React from 'react';
import Menu from './Menu';

const MainMenu = () => {
  return (
    <div className="ec-main-menu">
      <Menu isMobile={false} />
    </div>
  );
};

export default MainMenu;